import React from 'react';
import { useQueryClient } from 'react-query';
import _ from "underscore";
import axios from "axios";

import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Popper from "@material-ui/core/Popper";
import { getApiSitePrefix } from "../../../functions/SiteDefaults";
import { useAirports } from "../../../services/airports";
import {Box} from "@material-ui/core";

const apiSitePrefix = getApiSitePrefix();

/* eslint-disable no-use-before-define */
const styles = (theme) => ({
  popper: {
    maxWidth: "fit-content"
  }
});

const getServiceProviders = async (airport) => {
  try {
    const response = await axios.get(`${apiSitePrefix}/servicetypes/airport/${airport}`);
    if (!response.data) {
      console.log(`Could not get service providers for ${airport}`);
      return null;
    }
    return response.data;
  } catch (err) {
    console.log(`Could not get service providers for ${airport} with error: ${err.message}`);
    return null
  }
}

const AirportLookup = props => {
  const queryClient = useQueryClient();
  const extraKeys = [];
  const records = useAirports({queryClient, useCache: true, extraKeys});

  const {inputLabelProps, shrink} = {
    inputlabelProps: {},
    shrink: false,
    ...props
  }

  const handleChange = async (event, record) => {
    if (event.key === 'Enter') {
      event.stopPropagation()
    }
    if (props.returnType === "object") {
      const returnObject = { value: record?.airportCode||'', found: false, data: {}}
      if (record) {
        if (props.serviceProviders) {
          const serviceProviders = await getServiceProviders(record.airportCode);
          returnObject["serviceProviders"] = serviceProviders;
        }
        returnObject.found = true;
        returnObject.data = record;
      }
      props.onChange(returnObject);
    } else {
      if (!record) {
        props.onChange("");
      } else {
        props.onChange(record.airportCode);
      }
    }
  }
  const handleInputChange = (event, value) => {
    const inputValue = `${event?.target?.value}`;
    if (!value && event?.type==='blur') {
      value = inputValue.trim().toUpperCase()
    }
    if (!event || (event.type !== 'change' && !(event.type === 'blur' && (value || inputValue)))) return;
    if (props.returnType === "object") {
      const returnObject = { value, found: false, data: {} }
      const record = _.findWhere(records.data, { airportCode: value });
      if (record) {
        returnObject.found = true;
        returnObject.data = record;
      } else {
        if (event?.type==='blur') {
          returnObject.value='';
        }
      }
      props.onChange(returnObject);
    } else {
      if (event.type === 'blur'){
        const record = _.findWhere(records.data, { airportCode: value });
        if (!record) {
          value = "";
        } else {
          value = record.airportCode;
        }
      }
      props.onChange(value);
    }
  }

  const DropdownList = function (props) {
    return <Popper {...props} style={styles.popper} placement="bottom-start" />;
  };

  const defaultFilterOptions = (options, state) => {
    if (state.inputValue && state.inputValue.length === 3) {
      const airportCode = state.inputValue.toUpperCase();
      return _.filter(options, (airport) => airport.airportCode && airport.airportCode.startsWith(airportCode));
    } else if (state.inputValue && state.inputValue.length === 4) {
      const airportCode = state.inputValue.toUpperCase();
      return _.filter(options, (airport) => airport.icaoCode && airport.icaoCode.startsWith(airportCode));
    } else if (state.inputValue && state.inputValue.length > 4) {
      const airportCode = state.inputValue.toUpperCase();
      return _.filter(options, (airport) => airport.airportName?.toUpperCase().indexOf(airportCode) > -1);
    } else return [];//options.slice(0, 300);
}
  const filterOptions = props.filterOptions || defaultFilterOptions;

  return (
    <Autocomplete
      id={props.id}
      disableClearable={props.disableClearable===undefined?true:props.disableClearable}
      autoSelect={true}
      autoHighlight={true}
      inputValue={props.value}
      options={records.data||[]}
      filterOptions={filterOptions}
      PopperComponent={DropdownList}
      getOptionSelected={(option, value) => option.airportCode === value.airportCode}
      getOptionLabel={(option) => option.airportCode}
      noOptionsText="Type first characters of airport code or name"
      onChange={handleChange}
      onInputChange={handleInputChange}
//      onBlur={handleBlur}
      disabled={props.disabled||props.readOnly}
      renderOption={(option) => (
        <div>
          <React.Fragment>
            {option.airportCode} - {option.airportName}
          </React.Fragment>
          {option.blacklisted
            ?
              <Box
                component="img"
                sx={{
                  height: 25,
                  width: 35,
                }}
                alt="Blacklisted"
                src={"images/blacklisted.png"}
                style={{marginLeft: 15, marginBottom: -5}}
              />
            :
            <></>
          }
        </div>
      )}
      style={{
        width: (props.width||"100%"),
      }}
      renderInput={(params) => (
        <TextField
          {...params}
//          style={{marginBottom: -2}}
          label={props.label}
          placeholder={props.placeHolder}
          inputProps={{
            ...params.inputProps,
          }}
          InputLabelProps={{
            shrink, ...inputLabelProps
          }}
        />
      )}
    />
  )

}

export default withStyles(styles) (AirportLookup);
